// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".gif[data-v-0b112c29]{height:16.5625rem;overflow:hidden;position:relative;width:16.5625rem}.gif img[data-v-0b112c29]{height:auto;left:50%;min-height:100%;min-width:170%;position:absolute;top:50%;transform:translate(-50%,-50%);width:auto}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
